let default_title = process.env.VUE_APP_SEO_TITLE;
let default_description = process.env.VUE_APP_SEO_DESCRIPTION;
let default_fav_icon = process.env.VUE_APP_SEO_FAV;
let default_key_words = process.env.VUE_APP_SEO_KEYWORDS;
let default_image = process.env.VUE_APP_SEO_IMAGE;

export default {
  title: default_title || 'Welcome to KodeFast',
  description: default_description || 'Start building your automation today.',
  favicon: default_fav_icon || 'favicon.png',
  keywords: default_key_words || 'kodefast, onboarding, automation',
  image: default_image || 'https://kodefast.net/images/logo.webp',
};
